export const FETCH_FORECAST_AGGREGATE_DETAILS = (organizationId: string) => {
  return `/base/submission-requests/${organizationId}/forecast/aggregate`;
};
